import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-add-bank',
  templateUrl: './add-bank.component.html',
  styleUrls: ['./add-bank.component.css']
})
export class AddBankComponent implements OnInit {
addbank:any={};
disableBtn:Number;
  constructor(private dataservice:DataserviceService, private router:Router) { }

  ngOnInit() {
    this.disableBtn=0;
  }



  addBank(data1){
    this.disableBtn=1;
console.log(data1);

this.dataservice.addBank1(data1).subscribe(
  data=>{
    console.log(data);
    this.router.navigate(['/banks']);
    
  }
)
  }


}
